import React from 'react'

const InsightKPIFlowView =(props)=>{
    const {viewData, activeOption, deviceInfo} = props

    const currentOption = activeOption;// || viewData.DefaultOption;

    //var data = viewData.ViewData[currentOption].ChartData[1];
    const getPercentProps = (percentBetterMode, percentShowMode, progress, variance) => {
        // Returns { direction: 'up'|'down', color: '#hex' } or null
        let value = percentShowMode === 'P' ? progress : variance;

        if (percentBetterMode === 'P') {
            if (value > 0) return {direction: 'up', color: '#43a047' };      // Up green
            if (value < 0) return { direction: 'down', color: '#ff1744' };    // Down red
        } else if (percentBetterMode === 'N') {
            if (value < 0) return { direction: 'down', color: '#43a047' };    // Down green
            if (value > 0) return { direction: 'up', color: '#ff1744' };      // Up red
        }

        return null;
    }
    
    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].StatData){
        
        // console.log("layout response view", viewData.ViewData[currentOption]);

        //default is ignore for percent show mode and percent better mode
        const percentShowMode = viewData.ViewOptions?.percentShowMode || 'I';
        const percentBetterMode = viewData.ViewOptions?.percentBetterMode || 'I';
        const contentClass = viewData.ViewOptions?.contentClass || "";
        const decoratorClass = viewData.ViewOptions?.decoratorClass || "";
        const valueSuffix = viewData.ViewOptions?.valueSuffix || "";
        const renderDecoratorAfter = decoratorClass.includes("After");
        const decoratorPlacementClass = decoratorClass ? (renderDecoratorAfter ? "uiInsightKPIDecoratorAfter" : "uiInsightKPIDecoratorBefore") : "";
        
        const percentProps = getPercentProps(percentBetterMode, percentShowMode, 
            viewData.ViewData[currentOption].StatData.ProgressPercent, 
            viewData.ViewData[currentOption].StatData.VariancePercent);

        const optionData = viewData.ViewData[currentOption];
        const decorator = decoratorClass ? <span className={`uiInsightKPIFlowDecorator ${decoratorClass}`}></span> : null;

        return (
            <div className={`uiInsightKPIFlowView ${contentClass} ${decoratorPlacementClass}`}>
                {!renderDecoratorAfter ? decorator : null}
                <div className='uiInsightKPIFlowMain'>
                    <div className='uiInsightKPIFlowValueGroup'>
                        <span className='uiInsightKPIFlowValue'>{optionData.StatData.StatValueF}</span> 
                        <span className='uiInsightKPIFlowUnit'>{optionData.Y_AXIS_Title}</span>
                        {valueSuffix ? <span className='uiInsightKPIFlowSuffix'>{valueSuffix}</span> : null}
                        {
                            viewData.ViewOptions?.showBaseLine || (0 === 1 && !deviceInfo.isTabletWidth && optionData.StatData.BaseLineValue !== 0 && (
                                <span className='uiInsightKPIFlowBaseline'>/ {optionData.StatData.BaseLineValueF}</span>
                            ))
                        } 
                    </div>
                    {percentShowMode !== 'I' && <div className='uiInsightKPIFlowPercent'>
                        {percentProps && percentBetterMode !== 'I' && (
                            <>
                                <svg className='uiInsightKPIFlowPercentIcon' width="16" height="16">
                                    {percentProps.direction === 'up' ? (
                                        <polygon points="8,3 15,13 1,13" fill={percentProps.color} />
                                    ) : (
                                        <polygon points="8,13 15,3 1,3" fill={percentProps.color} />
                                    )}
                                </svg>
                            </>
                        )}
                        <span className='uiInsightKPIFlowPercentValue'>{percentShowMode === 'P' ? optionData.StatData.ProgressPercentF : optionData.StatData.VariancePercentF}</span> 
                        <span className='uiInsightKPIFlowPercentUnit'>%</span>
                    </div>}
                </div>
                {renderDecoratorAfter ? decorator : null}
            </div>
        )
    }

    return null;
}

export default InsightKPIFlowView
